import { render, staticRenderFns } from "./roleShop.vue?vue&type=template&id=4e96408b&scoped=true"
import script from "./roleShop.vue?vue&type=script&lang=js"
export * from "./roleShop.vue?vue&type=script&lang=js"
import style0 from "./roleShop.vue?vue&type=style&index=0&id=4e96408b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e96408b",
  null
  
)

export default component.exports